













import Vue from 'vue'
import { ApiResponse } from '@/interfaces'

export default Vue.extend({
  data() {
    return {
      busy: false,
      key: '',
      paylinetoken: '',
      structure_id: '',
      final: false,
      title: 'Vérification du paiement',
      message: 'Le paiement est en cours de traitement. Veuillez patienter...',
      intervalId: null as number | null,
      attemptCount: 0,
      maxAttempts: 10,
    }
  },
  mounted() {
    this.key = this.$route.query.key as string
    this.paylinetoken = this.$route.query.paylinetoken as string
    this.structure_id = this.$route.query.s as string
    this.checkPayment()
    this.intervalId = window.setInterval(() => {
      if (!this.final) {
        this.checkPayment()
      }
    }, 10000)
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
  computed: {
    logoUrl(): string {
      return this.structure_id ? `${process.env.VUE_APP_API_URL}/structure/${this.structure_id}/logo` : ''
    },
  },
  methods: {
    checkPayment() {
      this.attemptCount += 1
      this.busy = true
      this.$api
        .get('/pay-check', {
          params: {
            key: this.key,
            paylinetoken: this.paylinetoken,
          },
        })
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          if (apiResponse.data) {
            this.final = apiResponse.data.final
            this.message = apiResponse.data.message

            if (this.final) {
              this.title = 'Vérification terminée'
              this.stopChecking()
            } else {
              if (this.attemptCount >= this.maxAttempts) {
                this.title = 'Paiement non reçu'
                this.message = "Nous n'avons pas reçu la confirmation de votre paiement."
                this.stopChecking()
              } else {
                this.title = `Vérification en cours... (${this.attemptCount}/${this.maxAttempts})`
              }
            }
          }
          else {
            this.title = 'Erreur technique :('
            this.message = 'Impossible de vérifier le paiement.'
            this.stopChecking()
          }
        })
        .catch((error) => {
          //console.error('Erreur lors de la vérification du paiement:', error)
          this.title = 'Erreur technique :('
          this.message = 'Impossible de vérifier le paiement.'
          this.stopChecking()
        })
        .finally(() => {
          this.busy = false
        })
    },
    stopChecking() {
      this.final = true
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
  },
})
